import React from "react";
import {
  Button,
  ButtonGroup,
  PanelFooter,
  PanelFooterColumn,
} from "@flixbus/honeycomb-react";
import type { WizardFooterProps } from "./WizardFooter.types";

// A function, not a component: Honeycomb's Panel resolves its sections by the
// direct child's component name, so the returned element must BE a PanelFooter
// (a <WizardFooter/> wrapper would hide it and break Panel's section lookup).
// Called inline as {wizardFooter({...})} so PanelFooter stays a direct child.
export const wizardFooter = ({
  currentStep,
  refDataLoading,
  createLoading,
  nextDisabled,
  createDisabled,
  showAiDraft,
  onBack,
  onNext,
  onCreate,
  onDraftWithAi,
}: WizardFooterProps): React.ReactElement => {
  if (currentStep < 2) {
    return (
      <PanelFooter>
        <PanelFooterColumn narrow>
          {currentStep > 0 && (
            <Button appearance="secondary" onClick={onBack}>
              Back
            </Button>
          )}
        </PanelFooterColumn>
        <PanelFooterColumn narrow>
          <Button
            appearance="primary"
            loading={currentStep === 0 && refDataLoading}
            disabled={nextDisabled}
            onClick={onNext}
          >
            Next
          </Button>
        </PanelFooterColumn>
      </PanelFooter>
    );
  }

  // Step 3: Back on the left, primary actions on the right — one row.
  return (
    <PanelFooter>
      <PanelFooterColumn narrow>
        <Button appearance="secondary" onClick={onBack}>
          Back
        </Button>
      </PanelFooterColumn>
      <PanelFooterColumn narrow>
        <ButtonGroup justify="end">
          {showAiDraft && (
            <Button
              appearance="secondary"
              disabled={createDisabled}
              onClick={onDraftWithAi}
            >
              Draft with AI
            </Button>
          )}
          <Button
            appearance="primary"
            loading={createLoading || refDataLoading}
            disabled={createDisabled}
            onClick={onCreate}
          >
            Create
          </Button>
        </ButtonGroup>
      </PanelFooterColumn>
    </PanelFooter>
  );
};
